import ChatCompanion from '../lib/companion';

const actionPrefix = 'chat/companion/';

let companion;

export const mount = reportError => async dispatch => {
  if (companion) {
    throw new Error('Companion has already been mounted');
  }
  
  companion = new ChatCompanion(reportError);
  await companion.checkAvailability();
  return dispatch(checkAvailability(companion.isAvailable));
};

export const PRINT = `${actionPrefix}/print`;
export const PRINT_REQUEST = `${PRINT}/request`;
export const PRINT_FAIL = `${PRINT}/fail`;
export const printSentFile = (guid, name) => async dispatch => {
  dispatch({ type: PRINT_REQUEST });

  try {
    await companion.printByFileGuid(guid, name);
    return dispatch({ type: PRINT, guid, name });
  } catch (error) {
    return dispatch({ type: PRINT_FAIL, error });
  }
};

export const CHECK_AVAILABILITY = `${actionPrefix}/availablity`;
export const checkAvailability = available => ({ type: CHECK_AVAILABILITY, available });



// WEBPACK FOOTER //
// ./actions/chat/companion.js